import { useRouter } from 'next/router'

import { getBasePath } from '../utils/path'
import {
  PENGELOLAAN_KINERJA_PEJABAT_PENILAI_KINERJA_PS_PATH,
  PENGELOLAAN_KINERJA_TIM_KINERJA_PS_PATH,
} from 'app/KinerjaShared/constants/path'

export default function useBasePath() {
  const router = useRouter()
  const currentPath = router.asPath

  const isTimKinerjaPengawasSekolahUrl = currentPath.includes(
    PENGELOLAAN_KINERJA_TIM_KINERJA_PS_PATH
  )
  const isPPKPengawasSekolahUrl = currentPath.includes(
    PENGELOLAAN_KINERJA_PEJABAT_PENILAI_KINERJA_PS_PATH
  )

  const basePath = getBasePath(
    isTimKinerjaPengawasSekolahUrl,
    isPPKPengawasSekolahUrl
  )

  return { basePath, isTimKinerjaPengawasSekolahUrl, isPPKPengawasSekolahUrl }
}
